import store from '@/store'
import { getVuetify } from '@core/utils'
import { computed } from '@vue/composition-api'
import { updateTheme } from "@/api/index";
import { getCookie, setCookie } from '@/utils/cookie';


export default function useAppConfig() {
  const $vuetify = getVuetify()

  const appSkinVariant = computed({
    get: () => store.state.appConfig.app.skinVariant,
    set: value => {
      updateThemeFun({materioActiveTheme: value == 'default' ? 0 : value == 'bordered' ? 1 : 2}, 'skinVariant')
    },
  })

  const isDark = computed({
    get: () => $vuetify.theme.dark,
    set: value => {
      updateThemeFun({materioSkinVariant: value ? 1 : 0}, 'dark')
    },
  })

  const appContentWidth = computed({
    get: () => store.state.appConfig.app.contentWidth,
    set: value => {
      updateThemeFun({appContentWidth: value == "full" ? 0 : 1}, 'contentWidth')
    },
  })

  const appBarType = computed({
    get: () => store.state.appConfig.appBar.type,
    set: value => {
      updateThemeFun({appBarType: value == "fixed" ? 0 : value == "static" ? 1 : 2}, 'type')
    },
  })

  const menuIsVerticalNavMini = computed({
    get: () => store.state.appConfig.menu.isVerticalNavMini,
    set: value => {
      updateThemeFun({materioVerticalNavMini: value ? 1 : 0}, 'isVerticalNavMini')
    },
  })

  const menuIsMenuHidden = computed({
    get: () => store.state.appConfig.menu.isMenuHidden,
    set: value => {
      updateThemeFun({materioIsMenuHidden: value ? 1 : 0}, 'isMenuHidden')
    },
  })



  const appContentLayoutNav = computed({
    get: () => store.state.appConfig.app.contentLayoutNav,
    set: value => {
      store.commit('appConfig/UPDATE_CONTENT_LAYOUT_NAV', value)
    },
  })

  const appRouteTransition = computed({
    get: () => store.state.appConfig.app.routeTransition,
    set: value => {
      store.commit('appConfig/UPDATE_APP_ROUTE_TRANSITION', value)
    },
  })


  const appBarIsBlurred = computed({
    get: () => store.state.appConfig.appBar.isBlurred,
    set: value => {
      store.commit('appConfig/UPDATE_APP_BAR_IS_BLURRED', value)
    },
  })

  const footerType = computed({
    get: () => store.state.appConfig.footer.type,
    set: value => {
      store.commit('appConfig/UPDATE_FOOTER_TYPE', value)
    },
  })
  const isRtl = computed({
    get: () => $vuetify.rtl,
    set: value => {
      $vuetify.rtl = value
    },
  })

  const themes = computed({
    get: () => $vuetify.theme.themes,
    set: value => {
      store.commit('appConfig/UPDATE_THEMES', value)

      // ? We have to assign light and dark individually to make it reflect changes in UI
      // ! `$vuetify.theme.themes = value` isn't reactive
      $vuetify.theme.themes.light = value.light
      $vuetify.theme.themes.dark = value.dark
    },
  })

  return {
    appContentLayoutNav,
    appRouteTransition,
    appSkinVariant,
    appContentWidth,
    menuIsMenuHidden,
    menuIsVerticalNavMini,
    appBarType,
    appBarIsBlurred,
    footerType,
    isDark,
    isRtl,
    themes,
  }
}


function updateThemeFun(params, key) {
  updateTheme(params).then(res=> {
    if(res.code == 200) {
      switch (key) {
        case 'skinVariant':
          store.commit('appConfig/UPDATE_APP_SKIN_VARIANT', value)
          localStorage.setItem('materio-skin-variant', value)
          break;
        case 'dark':
          $vuetify.theme.dark = value
          localStorage.setItem('materio-active-theme', value == 0 ? 'dark' : 'light')
          setCookie('materio-active-theme',value == 0 ? 'dark' : 'light')
          break;
        case 'contentWidth':
          store.commit('appConfig/UPDATE_APP_CONTENT_WIDTH', value)
          break;
        case 'type':
          store.commit('appConfig/UPDATE_APP_BAR_TYPE', value)
          break;
        case 'isVerticalNavMini':
          store.commit('appConfig/TOGGLE_MENU_VERTICAL_NAV_MINI', value)
          break;
        case 'isMenuHidden':
          store.commit('appConfig/TOGGLE_MENU_MENU_HIDDEN', value)
          break;
      }
    }
  })
}